export default __webpack_public_path__ + "static/media/loading-dark.771c41f2.svg";